export default __webpack_public_path__ + "static/NuvemFiscalHome4Cortado-1fe4305fecd9d26c1251b9d3ba5859dc.png";